export const blockchainData = [
  {
    title: "What is Blockchain?",
    content: [
      {
        type: "heading",
        text: "The Foundation of Web3"
      },
      {
        type: "paragraph",
        text: "Blockchain is a revolutionary technology that serves as the backbone of Web3, cryptocurrencies, and decentralized applications. At its core, blockchain is a distributed ledger technology that maintains a continuously growing list of records, called blocks, which are linked and secured using cryptography."
      },
      {
        type: "paragraph",
        text: "Think of blockchain as a digital ledger that is shared across multiple computers (nodes) in a network. Unlike traditional databases that are controlled by a single entity, blockchain operates on a decentralized network where no single party has complete control over the data."
      }
    ]
  },
  {
    title: "How Blockchain Works",
    content: [
      {
        type: "heading",
        text: "The Mechanics Behind the Technology"
      },
      {
        type: "paragraph",
        text: "Understanding how blockchain works is essential to grasping its revolutionary potential:"
      },
      {
        type: "list",
        items: [
          "Transaction Initiation: A user initiates a transaction or data entry",
          "Broadcasting: The transaction is broadcast to the network of participating nodes",
          "Validation: Network nodes validate the transaction using predetermined rules",
          "Consensus: The network reaches consensus on the transaction's validity",
          "Block Creation: Valid transactions are grouped together into a new block",
          "Cryptographic Linking: The new block is cryptographically linked to the previous block",
          "Distribution: The updated blockchain is distributed across all network nodes"
        ]
      }
    ]
  },
  {
    title: "Key Components of Blockchain",
    content: [
      {
        type: "heading",
        text: "Essential Elements"
      },
      {
        type: "paragraph",
        text: "Blockchain technology consists of several key components that work together:"
      },
      {
        type: "list",
        items: [
          "Blocks: Containers that hold batches of valid transactions",
          "Hash Functions: Mathematical algorithms that create unique fingerprints for data",
          "Merkle Trees: Data structures that efficiently summarize transactions in a block",
          "Digital Signatures: Cryptographic proofs of transaction authenticity",
          "Consensus Mechanisms: Protocols for agreeing on network state",
          "Nodes: Individual computers that participate in the network"
        ]
      }
    ]
  },
  {
    title: "Types of Blockchain Networks",
    content: [
      {
        type: "heading",
        text: "Different Blockchain Architectures"
      },
      {
        type: "paragraph",
        text: "Blockchain networks can be categorized based on their accessibility and control:"
      },
      {
        type: "list",
        items: [
          "Public Blockchains: Open to everyone, fully decentralized (Bitcoin, Ethereum)",
          "Private Blockchains: Restricted access, controlled by an organization",
          "Consortium Blockchains: Semi-decentralized, controlled by a group of organizations",
          "Hybrid Blockchains: Combination of public and private elements"
        ]
      }
    ]
  },
  {
    title: "Blockchain Applications",
    content: [
      {
        type: "heading",
        text: "Real-World Use Cases"
      },
      {
        type: "paragraph",
        text: "Blockchain technology has applications across various industries:"
      },
      {
        type: "list",
        items: [
          "Cryptocurrencies: Digital money and payment systems",
          "Supply Chain Management: Tracking products from origin to consumer",
          "Healthcare: Secure patient records and drug traceability",
          "Voting Systems: Transparent and tamper-proof elections",
          "Real Estate: Property records and fractional ownership",
          "Identity Management: Self-sovereign digital identities",
          "Smart Contracts: Automated, self-executing agreements"
        ]
      }
    ]
  },
  {
    title: "Benefits and Challenges",
    content: [
      {
        type: "heading",
        text: "Advantages and Limitations"
      },
      {
        type: "paragraph",
        text: "Blockchain offers significant benefits but also faces challenges:"
      },
      {
        type: "list",
        items: [
          "Benefits: Decentralization, transparency, immutability, security, reduced costs",
          "Challenges: Scalability limitations, energy consumption, regulatory uncertainty",
          "Technical barriers: Complex implementation and maintenance",
          "Adoption hurdles: User education and infrastructure development"
        ]
      }
    ]
  }
];
